const routeTemplate = '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:day(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)?/:tab([-\\w\\d]+)?/:detail([-\\w\\d]+)?';
const hashRouteTemplate = [
    'gamePk',
    'game_view',
    'game_tab',
    'detail',
    'language',
    'timecode'
];

const routesConfig = [
    '/:gamepk(\\d+)',
    '/:gamepk(\\d+)/:view([-\\w\\d]+)',
    '/:gamepk(\\d+)/:view([-\\w\\d]+)?/:tab([-\\w\\d]+)',
    '/:gamepk(\\d+)/:view([-\\w\\d]+)?/:tab([-\\w\\d]+)?/:detail([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:gamepk(\\d+)',
    '/:teams([-\\w]+)?/:gamepk(\\d+)/:view([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:gamepk(\\d+)/:view([-\\w\\d]+)/:tab([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:gamepk(\\d+)/:view([-\\w\\d]+)?/:tab([-\\w\\d]+)?/:detail([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:gamepk(\\d+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)?/:tab([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)/:tab([-\\w\\d]+)?/:detail([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:gamepk(\\d+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)?/:tab([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)/:tab([-\\w\\d]+)?/:detail([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:day(\\d+)?/:gamepk(\\d+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:day(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:day(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)?/:tab([-\\w\\d]+)',
    '/:teams([-\\w]+)?/:year(\\d+)?/:month(\\d+)?/:day(\\d+)?/:gamepk(\\d+)/:view([-\\w\\d]+)/:tab([-\\w\\d]+)?/:detail([-\\w\\d]+)',
    routeTemplate
];

export default routesConfig;
export {
    routeTemplate,
    hashRouteTemplate
};
